export default __webpack_public_path__ + "static/media/cirec4.68dadfd7.png";